import { render, staticRenderFns } from "./ChevronLeftLight.vue?vue&type=template&id=e5a5faea"
import script from "./ChevronLeftLight.vue?vue&type=script&lang=ts"
export * from "./ChevronLeftLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports